import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=63cc6c88&scoped=true"
import script from "./Center.vue?vue&type=script&lang=js"
export * from "./Center.vue?vue&type=script&lang=js"
import style0 from "./Center.vue?vue&type=style&index=0&id=63cc6c88&prod&scoped=true&lang=css"
import style1 from "./Center.vue?vue&type=style&index=1&id=63cc6c88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc6c88",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QBtn,QCardActions,QInput,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QBtn,QCardActions,QInput})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
